<div
  #animsvg
  [ngStyle]="{ transform: 'rotate(' + rotation + 'deg)' }"
  (mouseenter)="mEnter()"
  (mouseleave)="mLeave()"></div>
